import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import parse from 'html-react-parser'
import Fade from 'react-reveal/Fade'

import Link from '../utils/link'
import { Arrow } from './icons'

const MachineBanner = ({ title = '', category = '', description = '', style = false, brand = null, button = null, backgroundImage = null, wpPage }) => {

  return (
    <>
      <section className='machine-banner'>
        <div className='machine-banner__padding' />
        <div className='machine-banner__inner'>
          <div className='machine-banner__bg'>
            {backgroundImage?.localFile &&
              <GatsbyImage image={getImage(backgroundImage?.localFile)} alt={title} />
            }
          </div>
          <Fade bottom distance={'40px'}>
            <div className={`machine-banner__content ${style ? 'machine-banner__content--dark' : ''}`}>
              {brand?.length > 0 && brand[0]?.featuredImage?.node?.localFile && 
                <Link to={brand[0]?.uri}>
                  <GatsbyImage image={getImage(brand[0].featuredImage.node.localFile)} alt={brand[0].title} />
                </Link>
              }
              {category && <div className='machine-banner__content-category'>{parse(category)}</div>}
              <h1 className='machine-banner__content-title'>{title && parse(title)}</h1>
              {description && <div className='machine-banner__content-description'>{parse(description)}</div>}
              {button?.url &&
                <Link to={button.url} className='machine-banner__button btn btn--arrow'>
                  <span>{button.title}</span>
                  <Arrow />
                </Link>
              }
            </div>
          </Fade>
        </div>
      </section>
    </>
  )
}

export default MachineBanner